import { render, staticRenderFns } from "./applyBusiness.vue?vue&type=template&id=1d4c15db&scoped=true&lang=html"
import script from "./applyBusiness.vue?vue&type=script&lang=js"
export * from "./applyBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c15db",
  null
  
)

export default component.exports